import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Box,
  Flex,
  Icon,
  Text,
  Tooltip,
  Link,
} from '@chakra-ui/react';
import { HelpCircle } from '@kula-ai/icons/outline/HelpCircle';
import { useAuth } from '@/hooks/use-auth';
import { BookOpen01 } from '@kula-ai/icons/outline/BookOpen01';
import { MessageChatSquare } from '@kula-ai/icons/outline/MessageChatSquare';
import { SUPPORT_HOME_URL } from '@/constants/app-constants';
import { usePylon } from '@/hooks/use-pylon';

export const NavLink = ({ icon, title, isCollapsed }) => {
  return (
    <Flex
      className="nav"
      alignItems="center"
      justifyContent="space-between"
      cursor="pointer"
      p="8px 12px"
      mb="2px"
      borderRadius="6px"
      _hover={{ bg: '#FFF' }}
      minHeight="42px"
    >
      <Flex alignItems="center">
        <Icon
          as={icon}
          width="18px"
          height="18px"
          color="primary-900"
          mr="10px"
        />
        {!isCollapsed && (
          <Text
            flex="1"
            size="sm-regular"
            color="primary-900"
            whiteSpace="nowrap"
          >
            {title}
          </Text>
        )}
      </Flex>
    </Flex>
  );
};

export const HelpSupport = ({ isCollapsed = false }) => {
  const { currUser } = useAuth();

  usePylon({
    appId: import.meta.env.VITE_PYLON_APP_ID,
    currUser,
  });

  return (
    <Menu placement="right">
      <Tooltip
        isDisabled={!isCollapsed}
        label="Help center"
        arrowSize={8}
        hasArrow
        placement="right"
        borderRadius="4px"
        variant="default"
      >
        <MenuButton
          as={Box}
          cursor="pointer"
          _hover={{ bg: '#FFF' }}
          borderRadius="6px"
        >
          <NavLink
            isCollapsed={isCollapsed}
            icon={HelpCircle}
            title="Help & Support"
          />
        </MenuButton>
      </Tooltip>
      <MenuList zIndex={9}>
        <MenuItem>
          <Icon as={BookOpen01} width="14px" height="14px" />
          <Link
            href={`${SUPPORT_HOME_URL}`}
            target="_blank"
            textDecoration="none"
          >
            <Text
              ml="4px"
              fontSize="14px"
              fontWeight="medium"
              textDecoration="none"
            >
              Help center
            </Text>
          </Link>
        </MenuItem>
        <MenuItem
          onClick={() => {
            window.Pylon('show');
          }}
        >
          <Icon as={MessageChatSquare} width="14px" height="14px" />
          <Text ml="4px" fontSize="14px" fontWeight="medium">
            Chat with us
          </Text>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
